var render = function render(){
  var _vm$items;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-card', {
    staticClass: "infocard",
    "class": {
      'infocard--dense': _vm.dense,
      'infocard--with-tags': _vm.visibleTags.length > 0
    },
    attrs: {
      "elevation": _vm.elevation
    }
  }, [_c('div', {
    staticClass: "infocard__layout"
  }, [_c('div', {
    staticClass: "infocard__main"
  }, [_vm.hasTitleBarContent ? _c('v-card-title', {
    staticClass: "d-flex",
    "class": _vm.dense ? 'py-2 px-3 infocard__title-bar--dense' : 'pb-4'
  }, [_c('div', {
    staticClass: "flex-grow-1 d-flex align-center flex-wrap",
    staticStyle: {
      "gap": "8px"
    }
  }, [_vm.titleIcon ? _c('v-icon', {
    attrs: {
      "small": "",
      "color": "primary"
    }
  }, [_vm._v(_vm._s(_vm.titleIcon))]) : _vm._e(), _vm.title ? _c('span', [_vm._v(_vm._s(_vm.title))]) : _vm._e(), _vm._t("title-append")], 2), _c('div', {
    staticClass: "d-flex align-center flex-wrap",
    staticStyle: {
      "gap": "8px"
    }
  }, [_vm._t("title-actions"), _vm.extratitle ? _c('div', {
    staticClass: "font-italic font-weight-regular mr-2"
  }, [_vm._v(" " + _vm._s(_vm.extratitle) + " ")]) : _vm._e()], 2)]) : _vm._e(), _c('v-card-text', {
    "class": _vm.dense ? 'py-2 px-3' : 'pb-4'
  }, [_vm.error ? _c('div', [_vm._v(" " + _vm._s(_vm.$translate("errorFetchingInformation")) + " ")]) : !((_vm$items = _vm.items) !== null && _vm$items !== void 0 && _vm$items.length) ? _c('div', [_vm._t("empty", function () {
    return [_c('div', {
      staticClass: "d-flex flex-grow-1 align-center"
    }, [_c('v-icon', {
      staticClass: "mr-2"
    }, [_vm._v("mdi-alert-octagon-outline")]), _vm._v(_vm._s(_vm.warning || _vm.$translate("noData")) + " ")], 1)];
  })], 2) : _vm.dense ? _c('dl', {
    staticClass: "infocard__dense-list",
    style: {
      gridTemplateColumns: "repeat(".concat(_vm.denseCols, ", minmax(0, 1fr))")
    }
  }, _vm._l(_vm.items, function (item, key) {
    return _c('div', {
      key: key,
      staticClass: "infocard__dense-row"
    }, [_c('dt', {
      staticClass: "infocard__dense-label"
    }, [item.icon ? _c('v-icon', {
      staticClass: "mr-1",
      attrs: {
        "size": "14",
        "color": "primary"
      }
    }, [_vm._v(" " + _vm._s(_vm.iconName(item.icon) || item.icon) + " ")]) : _vm._e(), _c('span', [_vm._v(_vm._s(item.title))]), item.valueTooltip ? _c('v-tooltip', {
      attrs: {
        "bottom": "",
        "max-width": "320"
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function fn(_ref) {
          var on = _ref.on,
            attrs = _ref.attrs;
          return [_c('v-icon', _vm._g(_vm._b({
            staticClass: "ml-1 infocard__value-tooltip-icon",
            attrs: {
              "x-small": "",
              "color": "grey"
            }
          }, 'v-icon', attrs, false), on), [_vm._v(" mdi-information-outline ")])];
        }
      }], null, true)
    }, [_c('span', [_vm._v(_vm._s(item.valueTooltip))])]) : _vm._e()], 1), _c('span', {
      staticClass: "infocard__dense-leader",
      attrs: {
        "aria-hidden": "true"
      }
    }), _c('dd', {
      staticClass: "infocard__dense-value copyable-row",
      "class": [item.color ? "".concat(item.color, "--text") : 'grey--text text--darken-2']
    }, [_c('span', {
      staticClass: "copyable-content"
    }, [item.link ? [_c(item.bold ? 'b' : 'span', {
      tag: "component"
    }, [_vm.isDict(item.link) ? _c('ScopedRouteLink', {
      attrs: {
        "to": item.link
      }
    }, [_vm._v(" " + _vm._s(item.value || "-") + " ")]) : _c('a', {
      attrs: {
        "target": "_blank",
        "href": item.link
      }
    }, [_vm._v(" " + _vm._s(item.value || _vm.$translate("link")) + " ")])], 1)] : item.lookup ? [_c('Lookup', {
      attrs: {
        "object": item.lookup.object,
        "params": item.lookup.params
      }
    }, [_vm._v(_vm._s(item.value))])] : item.chips ? [_c('span', {
      staticClass: "d-inline-flex flex-wrap gap-1"
    }, _vm._l(item.chips, function (chip, chipIndex) {
      return _c('v-chip', {
        key: chipIndex,
        attrs: {
          "small": chip.size === 'small',
          "x-small": chip.size !== 'small',
          "color": chip.color || 'grey',
          "text-color": "white"
        }
      }, [_vm._v(" " + _vm._s(chip.text || chip) + " ")]);
    }), 1)] : item.value ? [_c(item.bold ? 'b' : 'span', {
      tag: "component"
    }, [_vm._v(_vm._s(_vm.denseValueText(item)))])] : !item.action ? [_vm._v("-")] : _vm._e(), item.action ? [item.value ? [_vm._v(" - ")] : _vm._e(), _c('a', {
      staticClass: "text-primary",
      attrs: {
        "href": "#"
      },
      on: {
        "click": function click($event) {
          $event.preventDefault();
          return _vm.$emit(item.action);
        }
      }
    }, [_vm._v(_vm._s(item.action_text))])] : _vm._e()], 2), _vm.getCopyableValue(item) ? _c('v-btn', {
      staticClass: "copy-btn",
      attrs: {
        "x-small": "",
        "icon": ""
      },
      on: {
        "click": function click($event) {
          $event.stopPropagation();
          _vm.copyToClipboard(_vm.getCopyableValue(item));
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "x-small": ""
      }
    }, [_vm._v("mdi-content-copy")])], 1) : _vm._e()], 1)]);
  }), 0) : _c('div', {
    staticClass: "infocard__grid",
    style: _vm.gridStyle
  }, _vm._l(_vm.items, function (item, key) {
    return _c('div', {
      key: key,
      staticClass: "infocard__grid-item d-flex",
      "class": {
        'infocard__grid-item--large': item.large
      }
    }, [_c('div', {
      staticClass: "d-flex align-center infocard__item",
      "class": {
        borders: _vm.borders
      }
    }, [item.icon ? _c('div', {
      staticClass: "iconwrapper"
    }, [_c('v-icon', {
      attrs: {
        "size": "12",
        "color": "primary",
        "circle": ""
      }
    }, [_vm._v(" " + _vm._s(_vm.iconName(item.icon) || item.icon) + " ")])], 1) : _vm._e(), _c('div', {
      staticClass: "flex-grow-1"
    }, [_c('div', {
      staticClass: "infocard__title d-flex align-center"
    }, [_c('span', [_vm._v(_vm._s(item.title))]), item.valueTooltip ? _c('v-tooltip', {
      attrs: {
        "bottom": "",
        "max-width": "320"
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function fn(_ref2) {
          var on = _ref2.on,
            attrs = _ref2.attrs;
          return [_c('v-icon', _vm._g(_vm._b({
            staticClass: "ml-1 infocard__value-tooltip-icon",
            attrs: {
              "x-small": "",
              "color": "grey"
            }
          }, 'v-icon', attrs, false), on), [_vm._v(" mdi-information-outline ")])];
        }
      }], null, true)
    }, [_c('span', [_vm._v(_vm._s(item.valueTooltip))])]) : _vm._e()], 1), _c('div', {
      staticClass: "infocard__text copyable-row",
      "class": [item.color ? "".concat(item.color, "--text") : 'grey--text text--darken-2']
    }, [_c('div', {
      staticClass: "copyable-content"
    }, [item.link ? [_c(item.bold ? 'b' : 'span', {
      tag: "component"
    }, [item.preview ? _c(_vm.getPreviewComponent(item.preview.type), {
      tag: "component",
      attrs: {
        "order-id": item.preview.type === 'customerorder' || item.preview.type === 'providerorder' ? item.preview.id : undefined,
        "shipment-id": item.preview.type === 'shipment' ? item.preview.id : undefined,
        "receipt-id": item.preview.type === 'receipt' ? item.preview.id : undefined,
        "customer-id": item.preview.type === 'customer' ? item.preview.id : undefined,
        "invoice-id": item.preview.type === 'customerinvoice' || item.preview.type === 'providerinvoice' ? item.preview.id : undefined,
        "delay": 1000
      }
    }, [_vm.isDict(item.link) ? _c('ScopedRouteLink', {
      attrs: {
        "to": item.link
      }
    }, [_vm._v(" " + _vm._s(item.value || "-") + " ")]) : _c('a', {
      attrs: {
        "target": "_blank",
        "href": item.link
      }
    }, [_vm._v(" " + _vm._s(item.value || _vm.$translate("link")) + " ")])], 1) : [_vm.isDict(item.link) ? _c('ScopedRouteLink', {
      attrs: {
        "to": item.link
      }
    }, [_vm._v(" " + _vm._s(item.value || "-") + " ")]) : _c('a', {
      attrs: {
        "target": "_blank",
        "href": item.link
      }
    }, [_vm._v(" " + _vm._s(item.value || _vm.$translate("link")) + " ")])]], 2)] : item.lookup ? [_c('Lookup', {
      attrs: {
        "object": item.lookup.object,
        "params": item.lookup.params
      }
    }, [_vm._v(_vm._s(item.value))])] : [item.chips ? [_c('div', {
      staticClass: "d-flex flex-wrap gap-1"
    }, _vm._l(item.chips, function (chip, chipIndex) {
      return _c('v-chip', {
        key: chipIndex,
        staticClass: "mr-1 mb-1",
        attrs: {
          "small": chip.size === 'small',
          "x-small": chip.size !== 'small',
          "color": chip.color || 'grey',
          "text-color": "white"
        }
      }, [_vm._v(" " + _vm._s(chip.text || chip) + " ")]);
    }), 1)] : item.value ? [_c('div', {
      staticClass: "infocard__value-block",
      "class": {
        'infocard__value-block--clamped': _vm.shouldClamp(item, key),
        'infocard__value-block--inline': !_vm.shouldClamp(item, key) && !item.pre
      },
      style: _vm.clampStyle(item)
    }, _vm._l(_vm.lines(item), function (line, count) {
      return _c(item.pre ? 'pre' : item.bold ? 'b' : 'span', {
        key: count,
        tag: "component",
        staticClass: "whitespace-pre-wrap"
      }, [count ? _c('br') : _vm._e(), line ? [_vm.isObject(line) ? [_c('span', [_vm._v(_vm._s(line.title))]), line.link ? [_vm._v(" - "), _c('span', {
        staticClass: "link",
        on: {
          "click": function click($event) {
            return _vm.$emit(line.link.event, line.link.event_data);
          }
        }
      }, [_vm._v(_vm._s(line.link.title))])] : _vm._e()] : [_c('span', {}, [_vm._v(_vm._s(line))])]] : _vm._e()], 2);
    }), 1), _vm.isTruncatable(item, key) ? _c('a', {
      staticClass: "infocard__expand-link text-primary",
      attrs: {
        "href": "#"
      },
      on: {
        "click": function click($event) {
          $event.preventDefault();
          return _vm.toggleItemExpanded(key);
        }
      }
    }, [_vm._v(" " + _vm._s(_vm.isItemExpanded(key) ? _vm.$translate("showLess") : _vm.$translate("showMore")) + " ")]) : _vm._e()] : !item.action ? [_vm._v(" - ")] : _vm._e()], item.action ? [_vm.lines(item).length > 1 ? _c('br') : item.value ? [_vm._v(" -  ")] : _vm._e(), item.action ? _c('a', {
      staticClass: "text-primary",
      attrs: {
        "href": "#"
      },
      on: {
        "click": function click($event) {
          $event.preventDefault();
          return _vm.$emit(item.action);
        }
      }
    }, [_vm._v(_vm._s(item.action_text))]) : _vm._e()] : _vm._e()], 2), _vm.getCopyableValue(item) ? _c('v-btn', {
      staticClass: "copy-btn",
      attrs: {
        "x-small": "",
        "icon": ""
      },
      on: {
        "click": function click($event) {
          $event.stopPropagation();
          _vm.copyToClipboard(_vm.getCopyableValue(item));
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "x-small": ""
      }
    }, [_vm._v("mdi-content-copy")])], 1) : _vm._e()], 1)])])]);
  }), 0), _vm._t("default")], 2)], 1), _vm.visibleTags.length ? _c('v-card-title', {
    staticClass: "infocard__tags",
    "class": {
      'infocard__tags--dense': _vm.dense
    }
  }, _vm._l(_vm.visibleTags, function (tag, tagIndex) {
    return _c('Tag', {
      key: tagIndex,
      attrs: {
        "tag": tag,
        "size": "small",
        "chip-class": "infocard__tag-chip"
      }
    });
  }), 1) : _vm._e()], 1)]);

}
var staticRenderFns = []

export { render, staticRenderFns }